/* eslint-disable jsdoc/require-jsdoc */
import { BtxType } from './interfaces/main.interface';

// tslint:disable: completed-docs
export const NAMESPACE = 'Authentication';
export const ID_PHONE_NUMBER_INPUT = 'phone-number-input';
export const ID_SMS_INPUT = 'sms-input';

// containers
export const CONTAINER_BTX_TEMPLATE = 'btx-template-container';
export const CONTAINER_PHONE_NUMBER = 'phone-number-container';
export const CONTAINER_SMS_CODE = 'sms-container';
export const CONTAINER_VALIDATE_PHONE_NUMBER_BTN = 'validate-phone-btn-container';
export const CONTAINER_AUTHENTICATE_BTN = 'authenticate-btn-container';
export const CONTAINER_RESET_BTN = 'reset-btn-container';
export const CONTAINER_LOADING_SPINNER = 'loading-spinner-container';
export const CONTAINER_MNP_NOTIFICATION = 'container-mnp-notification';
export const CONTAINER_ERROR_NOTIFICATION = 'container-error-notification';

// classes
export const CLASS_FIRST_STEP = 'first-step';
export const CLASS_SECOND_STEP = 'second-step';
export const CLASS_INPUT_DISABLED = 'ws10-form-element-block--disabled';

// url params, cookies, session storage
export const URL_PARAM_BTYPE = 'btype';
export const URL_PARAM_GOTO = 'goto';
export const URL_PARAM_SALES_CHANNEL = 'salesChannel';
export const URL_PARAMS: string[] = [
    URL_PARAM_BTYPE,
    URL_PARAM_GOTO,
    URL_PARAM_SALES_CHANNEL,
];
export const SESSION_SAILS_BNT = 'SAILS_BNT';
export const SESSION_SAILS_VVL = 'SAILS_VVL';
export const SESSION_CURIOSITY_FLOW = 'curiosity_flow';
export const SESSION_ELIGIBILITY_DATA = 'eligibility';
export const COOKIE_BSHOP_TOKEN = 'x-vf-bshoptoken-set';
export const COOKIE_USER_ID = 'vco_user_id';

// btx
export const BTX_DECIDE = 'decide';
export const BTX_VVL = 'vvl';
export const BTX_TARIFF_CHANGE = 'tariffChange';
export const BTX_MNP = 'mnp';
export const BTX_FORCE = 'force';
export const BTX_REDPLUS = 'redplus';
export const BTX_MULTICARD_CONTRACT = 'multicardContract';
export const BTX_MULTISIM = 'multisim';

export const BTX_VALID_VALUES: BtxType[] = [
    BTX_DECIDE,
    BTX_REDPLUS,
    BTX_MNP,
    BTX_FORCE,
    BTX_TARIFF_CHANGE,
    BTX_MULTICARD_CONTRACT,
    BTX_VVL,
    BTX_MULTISIM,
];

export const BTX_SPECIAL_CASES: BtxType[] = [
    BTX_DECIDE,
    BTX_VVL,
    BTX_TARIFF_CHANGE,
    BTX_REDPLUS,
    BTX_MULTICARD_CONTRACT,
    BTX_MULTISIM,
];

// customer types
export const CUSTOMER_TYPE_CONSUMER = 'consumer';
export const CUSTOMER_TYPE_YOUNG = 'young';
export const CUSTOMER_TYPE_SOHO = 'soho';
export const CUSTOMER_TYPE_FAF = 'familyfriends';
export const CUSTOMER_TYPE_SIMONLY = 'simonly';
export const CUSTOMER_TYPE_GIGAKOMBI = 'gigakombi';

// actions
export const ACTION_INIT_PAGE = `${NAMESPACE}/ACTION_INIT_PAGE` as const;
export const ACTION_INIT_PAGE_SUCCESS = `${NAMESPACE}/ACTION_INIT_PAGE_SUCCESS` as const;
export const ACTION_SEND_TAN = `${NAMESPACE}/SEND_TAN` as const;
export const ACTION_SEND_TAN_SUCCESS = `${NAMESPACE}/ACTION_SEND_TAN_SUCCESS` as const;
export const ACTION_LOGIN = `${NAMESPACE}/LOGIN` as const;
export const ACTION_ELIGIBILITY_CHECK = `${NAMESPACE}/ELIGIBILITY_CHECK` as const;
export const ACTION_ADD_COMPONENTS = `${NAMESPACE}/ADD_COMPONENTS` as const;
export const ACTION_SET_ERROR = `${NAMESPACE}/SET_ERROR` as const;
export const ACTION_SET_MTAN_STEP = `${NAMESPACE}/SET_MTAN_STEP` as const;
export const ACTION_SET_IS_LOGGED_IN = `${NAMESPACE}/ACTION_SET_IS_LOGGED_IN` as const;

// api
export const API_SEND_TAN = '/api/commerce/authentication/sendTan';
export const API_LOGIN = '/api/commerce/authentication/login';
export const API_ELIGIBILITY_TARIFFCHANGE = '/api/commerce/eligibility/inlifeTariffChange';
export const API_ELIGIBILITY_VVL = '/api/commerce/eligibility/contractProlongation';
export const API_ELIGIBILITY_REDPLUS = '/api/commerce/eligibility/redPlus';
export const API_ELIGIBILITY_MULTICARD_CONTRACT = '/api/commerce/eligibility/ultraCard';
export const API_ELIGIBILITY_GIGAKOMBI = '/api/commerce/eligibility/gigaKombi';
export const API_SUBSCRIPTION_DETAILS = '/api/commerce/subscriptionDetails';
export const API_CUSTOMER = '/api/commerce/customer';

// api headers
export const API_HEADER_ACCEPT = 'Accept';

// tracking
export const ADDITIONAL_CMS_SITE_STRUCTURE = ['privatkunden', 'authentication'];
export const ADDITIONAL_CMS_SITE_STRUCTURE_PROVIDE_MSISDN = 'provide msisdn';
export const ADDITIONAL_CMS_SITE_STRUCTURE_PROVIDE_SMS_CODE = 'provide sms code';
export const TRACKING_SITE_STATES = {
    0: ADDITIONAL_CMS_SITE_STRUCTURE_PROVIDE_MSISDN,
    1: ADDITIONAL_CMS_SITE_STRUCTURE_PROVIDE_SMS_CODE,
};
export const TRACKING_LOGGED_IN = 'logged in';
export const TRACKING_NOT_LOGGED_IN = 'not logged in';
export const TRACKING_SITE_AREA = 'service';
export const TRACKING_PAGE_TYPE = 'authentication';
export const TRACKING_PLATFORM_TYPE_RESPONSIVE = 'responsive';
export const TRACKING_ERROR_TYPE_VALIDATION = 'validation';
export const TRACKING_ERROR_TYPE_AUTHENTICATION = 'authentication';
export const TRACKING_ERROR_AREA_MSISDN = 'msisdn field';
export const TRACKING_ERROR_AREA_MTAN = 'mtan field';

// other
export const MEMBERTYPE_MEMBER = 'M';
export const MNP_FLOW = 'BMNP';

// error codes
export enum ErrorCodes {
    TechnicalError = '401',
    NotRedplusEligible = '2001',
    NotEnoughVacatSlotsRedplus = '2003',
    NotAllowedTariff = '2005',
    LoginFailed = '2006',
    NotOwner = '2007',
    NotEnoughVacatSlotsMulticard = '2031',
    NotVVLEligible = '2100',
    NotMulticardEligible = '2105',
    NotInlifeEligible = '21004',
}
